import { Children, ReactElement, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

import SelectableItem from './SelectableItem.tsx';
import Heading3 from './text/Heading3.tsx';

interface Props {
    title?: string;
    classNames?: {
        wrapper?: string;
        item?: string;
    };
    children: ReactNode;
    handleSelect: (key: string) => void;
    selectedItem: string | undefined;
}

export const SelectableList = ({ title, classNames, children, handleSelect, selectedItem }: Props) => {
    return (
        <div className={cn('flex flex-col gap-3', classNames?.wrapper)}>
            {title && <Heading3>{title}</Heading3>}
            {Children.map(children, (child) => {
                const childKey = (child as ReactElement).key ?? '';

                return (
                    <SelectableItem
                        key={`wrapper_${childKey}`}
                        isSelected={selectedItem === childKey}
                        onClick={() => handleSelect(childKey)}
                        className={classNames?.item}
                    >
                        {child}
                    </SelectableItem>
                );
            })}
        </div>
    );
};
